'use strict'

import ApiClient from './ApiClient'

export default class AttachmentRepository {
  // TODO 共通化
  setMgmtParam (isMgmt, params) {
    params = params || {}

    if (isMgmt) {
      params.is_mgmt = '1' // TODO this.app_flag.ON
    }

    return params
  }

  /**
   * 添付ファイル一覧を取得します。
   * @param {string|int} personId 人物ID
   * @param {bool} isMgmt 管理モードフラグ
   */
  getList (personId, isMgmt) {
    const params = this.setMgmtParam(isMgmt, { sid_person: personId })
    return ApiClient().get(`/attachments`, { params })
  }

  /**
   * 添付ファイルを追加します。
   * @param {string|int} personId 人物ID
   * @param {object} formData
   * @param {bool} isMgmt 管理モードフラグ
   */
  postList (personId, formData, isMgmt) {
    return ApiClient().post(`/attachments`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
      params: this.setMgmtParam(isMgmt, { sid_person: personId })
    })
  }

  /**
   * 添付ファイルの詳細を取得します。
   * @param {string|int} id 添付ID
   * @param {bool} isMgmt 管理モードフラグ
   */
  get (id, isMgmt) {
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/attachments/${id}`, { params })
  }

  /**
   * 添付ファイルを更新します。
   * @param {string|int} id 添付ID
   * @param {object} formData
   * @param {bool} isMgmt 管理モードフラグ
   */
  put (id, formData, isMgmt) {
    formData.append('_method', 'PUT')

    return ApiClient().post(`/attachments/${id}`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
      params: this.setMgmtParam(isMgmt)
    })
  }

  /**
   * 添付ファイルを削除します。
   * @param {string|int} id 添付ID
   * @param {bool} isMgmt 管理モードフラグ
   */
  delete (id, isMgmt) {
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().delete(`/attachments/${id}`, { params })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/AttachmentRepository.js